import { render, staticRenderFns } from "./bannerView.vue?vue&type=template&id=94a5dee2&scoped=true"
import script from "./bannerView.vue?vue&type=script&lang=js"
export * from "./bannerView.vue?vue&type=script&lang=js"
import style0 from "./bannerView.vue?vue&type=style&index=0&id=94a5dee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a5dee2",
  null
  
)

export default component.exports